import { action } from "satcheljs";

const timeOffReasonsChanged = action(
    "TIME_OFF_REASONS_CHANGED", () => ({})
);

export default timeOffReasonsChanged;
